<!--GeneratorFlag:[NoChange]-->
<template>
	<kaveh-excel-import :key="ver" :entity="entity" :task="import" stream-address="store/delivery-date-type/stream-create" @close="reset" @cancel="reset" />
</template>
<script>
	import { DeliveryDateType } from '@/modules/store/data/delivery-date-type/create'
	import { DeliveryDateTypeService } from '@/modules/store/services'
	export default {
		data()
		{
			return {
				ver: 0
			}
		},
		computed:
		{
			entity()
			{
				return DeliveryDateType;
			},

			service()
			{
				return new DeliveryDateTypeService();
			}
		},
		methods:
		{
			async import(payload)
			{
				return await this.service.create(payload, {HSR:false, HER:false});
			},

			reset()
			{
				this.ver = this.ver + 1;
			}
		}
	}
</script>